import { Component } from '@angular/core';

@Component({
    selector: 'app-workflow',
    templateUrl: './workflow.component.html',
    styleUrls: [],
    standalone: false
})
export class WorkflowComponent {}
